import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";
import { useDispatch } from "react-redux";
import notificationAction from "../../redux/notification/action";

export const EmployeeTask = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const employeeStore = useSelector((state) => state.employeeReducer);

  const getData = async () => {
    try {
      let payload = {
        employeeId: employeeStore?.employee?.employee?._id,
      };
      const response = await api.getTasksByEmployee(payload);
      console.log(response);
      if (response?.success) {
        setData(response?.tasks || []);
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    if (employeeStore?.employee?.employee?._id) {
      getData();
    }
  }, [employeeStore]);

  console.log(employeeStore);

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Tasks</h3>
            <Table data={data} getData={getData} />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
    </>
  );
};

const Table = ({ data, getData }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const [selectedTask, setSelectedTask] = useState({});
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (task) => {
    setSelectedTask(task);
    setShow(true);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Title
                </th>
                <th scope="col" className="">
                  Description
                </th>
                <th scope="col" className="">
                  Priority
                </th>

                <th scope="col" className="">
                  Status
                </th>
                <th scope="col" className="">
                  Created At
                </th>
                <th scope="col" className="">
                  Deadline
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.title}
                    </div>
                  </td>

                  <td>
                    <span className="table-text-dark taskDesc">
                      {item?.description}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.priority}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark d-flex ai-center db">
                      <div className="w-max-c">{item?.status}</div>
                      <i
                        className="fa-solid fa-pen-to-square ms-2"
                        onClick={() => handleShow(item)}
                      ></i>
                    </span>
                  </td>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.createdAt ? formatDate(item?.createdAt) : "-"}
                    </div>
                  </td>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {Array.isArray(item?.deadline)
                        ? item?.deadline.join(", ")
                        : item?.deadline
                        ? formatDate(item?.deadline)
                        : "-"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <EditTaskModal
        show={show}
        handleClose={handleClose}
        getData={getData}
        selectedTask={selectedTask}
        setSelectedTask={setSelectedTask}
      />
    </>
  );
};

const EditTaskModal = ({
  show,
  handleClose,
  getData,
  selectedTask,
  setSelectedTask,
}) => {
  const [employees, setEmployees] = useState([]);

  const dispatch = useDispatch();

  const employeeStore = useSelector((state) => state.employeeReducer);

  const handleSubmit = async () => {
    try {
      if (!selectedTask?.status) {
        notify.warning("Status is required");

        return;
      }
      let payload = {
        status: selectedTask?.status,
        taskId: selectedTask?._id,
      };
      console.log(payload);
      const response = await api.editTask(payload);
      console.log(response);
      if (response?.success) {
        getData();
        notify.success("Status successfully updated");
        dispatch(
          notificationAction.setNotification({
            title: selectedTask?.title,
            description: `Task "${selectedTask?.title}" was marked as ${selectedTask?.status} by ${employeeStore?.employee?.employee?.email || "Employee"}`,
            details: {
              taskName: selectedTask?.title,
              employeeEmail: employeeStore?.employee?.employee?.email,
              newStatus: selectedTask?.status,
              taskDescription: selectedTask?.description,
              updatedAt: new Date().toLocaleString()
            },
            type: "success",
          })
        );


        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setSelectedTask({ ...selectedTask, status: e.target.value });
  };
  console.log(selectedTask);

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Edit Task</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Task Title</label>
              <input
                type="text"
                name="title"
                value={selectedTask?.title}
                disabled
                className="form-control"
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Task Description</label>
              <textarea
                rows={3}
                name="description"
                className="form-control"
                value={selectedTask?.description}
                disabled
              ></textarea>
            </div>
          </div>

          <div className="col-12">
            <div className="form-group">
              <label>Status</label>
              <select
                name="status"
                className="form-control"
                onChange={(e) => onTextChange(e)}
                value={selectedTask?.status}
                defaultValue={selectedTask?.status}
              >
                <option value="">Select</option>
                <option value={"To Do"}>To Do</option>
                <option value={"In Progress"}>In Progress</option>
                <option value={"Completed"}>Completed</option>
              </select>
            </div>
          </div>
        </div>

        <div className="mt-4 ">
          <div className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};
